/**
 * Full-screen boot ONLY before Command shell can paint
 * (Clerk hydrate, org gate wait). Once AppHome mounts we use LiveOpsSkeleton
 * under the real header — never stack a second full-screen splash.
 */
export function CommandBootScreen({
  detail,
  host,
  error = false,
}: {
  detail?: string;
  host?: string;
  error?: boolean;
}) {
  return (
    <div
      className="flex min-h-[100dvh] flex-col bg-og-ink"
      role="status"
      aria-live="polite"
      aria-busy={!error}
    >
      {/* Same header height as AppHome — continuous shell chrome */}
      <header className="flex h-12 shrink-0 items-center gap-2.5 border-b border-white/10 bg-zinc-950/95 px-3 md:px-4">
        <img
          src="/og-logo.png"
          alt=""
          width={28}
          height={28}
          className="h-7 w-7 rounded-lg shadow shadow-orange-500/30"
        />
        <div className="leading-tight">
          <p className="text-sm font-semibold text-white">Command</p>
          <p className="text-[10px] uppercase tracking-wider text-zinc-500">
            Live Ops
          </p>
        </div>
      </header>

      <div className="relative flex min-h-0 flex-1 flex-col items-center justify-center">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 overflow-hidden"
        >
          <div className="absolute left-1/2 top-1/3 h-[28rem] w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-orange-500/15 blur-[100px]" />
          <div className="absolute bottom-0 right-1/4 h-[18rem] w-[18rem] rounded-full bg-violet-600/10 blur-[80px]" />
        </div>

        <div className="relative flex flex-col items-center gap-4 px-6 text-center">
          {!error ? (
            <span
              className="h-8 w-8 animate-spin rounded-full border-2 border-orange-400/25 border-t-orange-400"
              style={{ animationDuration: "0.85s" }}
              aria-hidden
            />
          ) : (
            <span className="h-2.5 w-2.5 rounded-full bg-red-400" aria-hidden />
          )}
          <div className="space-y-1">
            <p className="text-sm font-semibold tracking-tight text-white">
              {error ? "Couldn’t open Command" : "Opening Command"}
            </p>
            <p className="max-w-xs text-xs text-zinc-400">
              {error
                ? detail || "Check your connection, then try again."
                : detail || "Loading your workspace…"}
            </p>
            {host && !error ? (
              <p className="pt-1 font-mono text-[10px] text-zinc-600">{host}</p>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

/** @deprecated Prefer LiveOpsSkeleton under AppHome header for hub connect. */
export function CommandBootOverlay({
  detail,
  host,
  error = false,
}: {
  detail?: string;
  host?: string;
  error?: boolean;
}) {
  return (
    <div className="absolute inset-0 z-20 bg-og-ink" role="status" aria-live="polite">
      <CommandBootScreen detail={detail} host={host} error={error} />
    </div>
  );
}
